import React from 'react'
import { useTranslation } from 'react-i18next'
import GenericStatsDetails from './GenericStatsDetails'

const Invoices: React.FC = () => {
  const { t } = useTranslation()

  return <GenericStatsDetails entity='workorderInvoice' entityTranslation={t('global.stats.invoices')} icon='file alternate' />
}

export default Invoices
